import React from 'react';
import gridStyles from '../../../styles/DashboardV2.module.css';
import DashboardCard from './shared/DashboardCard';
import { useDashboardContext } from '../../../contexts/DashboardContext';

interface CompanyDashboardProps {
    userDetails: any;
}

const CompanyDashboard: React.FC<CompanyDashboardProps> = () => {
    const manager = useDashboardContext();
    const ffcStatus = manager?.companyFFC;
    const beeStatus = manager?.companyBBEE;
    const auditDeadline = manager?.companyAuditDeadline;
    const infoOfficerRegistered = manager?.companyBBEE?.informationOfficer?.registered || false;
    const infoOfficerName = manager?.companyBBEE?.informationOfficer?.name || '';

    const daysRemaining = auditDeadline?.days_remaining ?? null;

    const statusValueClass = (status?: string) => {
        if (status === 'Active') return gridStyles.statItemValueGreen;
        if (status === 'Expired') return gridStyles.statItemValueRed;
        return gridStyles.statItemValueAmber;
    };

    return (
        <div className={gridStyles.dashboardPage}>
            <div className={gridStyles.dashboardHeader}>
                <h1 className={gridStyles.dashboardTitle}>Company Dashboard</h1>
                <p className={gridStyles.dashboardSubtitle}>
                    Overview of company-level compliance and status
                </p>
            </div>

            <div className={gridStyles.dashboardGrid}>
                <div className={gridStyles.col3}>
                    <DashboardCard title="Company FFC Status">
                        <div className={ffcStatus ? `${gridStyles.statItemValue} ${statusValueClass(ffcStatus.status)}` : gridStyles.statItemValue}>
                            {ffcStatus ? ffcStatus.status : 'N/A'}
                        </div>
                        <div className={gridStyles.statItemLabel}>
                            {ffcStatus?.expiry ? `Expires: ${new Date(ffcStatus.expiry).toLocaleDateString()}` : 'Not recorded'}
                        </div>
                    </DashboardCard>
                </div>

                <div className={gridStyles.col3}>
                    <DashboardCard title="Company BEE Status">
                        <div className={beeStatus ? `${gridStyles.statItemValue} ${statusValueClass(beeStatus.status)}` : gridStyles.statItemValue}>
                            {beeStatus ? beeStatus.status : 'N/A'}
                        </div>
                        <div className={gridStyles.statItemLabel}>
                            {beeStatus?.expiry ? `Expires: ${new Date(beeStatus.expiry).toLocaleDateString()}` : 'Not recorded'}
                        </div>
                    </DashboardCard>
                </div>

                <div className={gridStyles.col3}>
                    <DashboardCard title="Audit Submission Deadline">
                        <div className={`${gridStyles.statItemValue} ${typeof daysRemaining === 'number' && daysRemaining < 45 ? gridStyles.statItemValueRed : ''}`}>
                            {daysRemaining ?? 'Not set'}
                        </div>
                        <div className={gridStyles.statItemLabel}>
                            {auditDeadline ? `Due: ${auditDeadline.financial_year_end.toLocaleDateString()}` : ''}
                        </div>
                    </DashboardCard>
                </div>

                <div className={gridStyles.col3}>
                    <DashboardCard title="Information Officer">
                        <div className={`${gridStyles.statItemValue} ${infoOfficerRegistered ? gridStyles.statItemValueGreen : gridStyles.statItemValueAmber}`}>
                            {infoOfficerRegistered ? 'Registered' : 'Not Registered'}
                        </div>
                        <div className={gridStyles.statItemLabel}>
                            {infoOfficerRegistered ? infoOfficerName : ''}
                        </div>
                    </DashboardCard>
                </div>
            </div>
        </div>
    );
}

export default CompanyDashboard;